import React from 'react';
import { Component, PuzzleButton } from "puzzle";
import PoliciesManager from "../Policies";
import { EMAIL_CLIENT_PARAMS, PROPS, STATE } from "./Types";
import { omit } from "lodash";

export default class OpenMailLink extends Component<PROPS, STATE> {

  /**
   * Creates mailto link for function: "openEmailClient" to open
   * @param emailClientParams
   */
  createMailtoLink = (emailClientParams: EMAIL_CLIENT_PARAMS) => {
    const { recipients = [] } = emailClientParams;
    let { message = "", subject = "" } = emailClientParams;

    const to: string = recipients.join(';');

    const encodedSubject = encodeURIComponent(subject);
    const encodedMessage = encodeURIComponent(message);

    return `mailto:${to}?subject=${encodedSubject}&body=${encodedMessage}`;
  }

  /**
   * Opens email client with predefined recipients, subject, and possible message
   * @param emailClientParams
   */
  openEmailClient = (emailClientParams: EMAIL_CLIENT_PARAMS) => {
    const mailtoLink = this.createMailtoLink(emailClientParams);
    window.location.href = mailtoLink;
  };

  renderBody() {
    const { policy, emailClientParams, children } = this.props;
    let propsParams = omit(this.props, ['emailClientParams']);
    return (
      PoliciesManager[policy] && children !== '-' ?
        <PuzzleButton
          {...propsParams}
          fillMode={"link"}
          themeColor={'primary'}
          className={'tp-grid-button tp-link tp-text-underline pd-open-mail-link-button'}
          size={'small'}
          onClick={this.openEmailClient.bind(this, emailClientParams)}>
          {children}
        </PuzzleButton> : children
    )
  }
}
